// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/templates/stylesheets/style.scss
 ** module id = 467
 ** module chunks = 1
 **/